import { Typography } from "@mui/material";
import { Row } from "./Row";

export const IconWithText = ({ icon, text }: { icon: React.ReactNode; text: string | React.ReactNode }) => {
  return (
    <Row gap="3px" alignItems="center">
      {icon}
      {typeof text === "string" ? (
        <Typography fontSize="11px" noWrap>
          {text}
        </Typography>
      ) : (
        text
      )}
    </Row>
  );
};
